import React, { useCallback, useEffect, useRef, useState } from 'react'
import { PageTitle } from '../../components/title/PageTitle'
import '../../css/Member.css'
import { postChangeMobile, postKaKao, postLogin, postSendCode, postVerifyCode } from '../../api/login'
import { colorObj } from '../../components/color'
import { postOpenid } from '../../api/auth'
import { handleAccessToken } from '../../js/script'
import { useNavigate } from 'react-router-dom'
import { detect } from 'detect-browser'

export default function PhoneModify({ setText, changePhone, changeEmail, closeModal }: any) {
  const [drop, setDrop] = useState<boolean>(false)
  const [phoneNumber, setPhoneNumber] = useState<string>('')
  const [messageId, setMessageId] = useState<string>('')
  const [phoneSubmit, setPhoneSubmit] = useState<boolean>(false)
  const [seconds, setSeconds] = useState<number>(20)
  const [codeFocus, setCodeFocus] = useState<boolean>(false)
  const [snsCheck, setSnsCheck] = useState<boolean>(false)
  const [code, setCode] = useState<string>('')
  const timerRef = useRef<HTMLDivElement>(null) // Add this line
  const [time, setTime] = useState<number>(3 * 60) // 3분을 초로 변환 (3분 * 60초)
  const [isActive, setIsActive] = useState<boolean>(false)
  const [phonecheck, setPhoneCheck] = useState<boolean>(false)
  const [codeCheck, setCodeCheck] = useState<boolean>(false)
  const [authCheck, setAuthCheck] = useState<boolean>(false)
  const [os, setOs] = useState<string>('')
  const navigate = useNavigate()

  useEffect(() => {
    const browerOs = detect()
    //@ts-ignore
    setOs(browerOs?.os)
  }, [])

  const decrementSeconds = useCallback(() => {
    setSeconds((prevSeconds) => prevSeconds - 1)
  }, [])

  useEffect(() => {
    if (phoneSubmit && seconds !== 0) {
      //@ts-ignore
      timerRef.current = setInterval(decrementSeconds, 1000) // Change this line
      //@ts-ignore
      return () => clearInterval(timerRef.current)
    }
  }, [decrementSeconds, phoneSubmit, seconds])

  useEffect(() => {
    if (seconds === 0) {
      //@ts-ignore
      clearInterval(timerRef.current) // Change this line
    }
  }, [seconds])

  useEffect(() => {
    let interval: any = null
    if (isActive && time > 0) {
      interval = setInterval(() => {
        setTime((time) => time - 1)
      }, 1000)
    } else if (time === 0) {
      clearInterval(interval)
      setIsActive(false)
    }
    return () => clearInterval(interval)
  }, [isActive, time])

  const formatTime = (seconds: any) => {
    const minutes = Math.floor(seconds / 60)
    const remainingSeconds = seconds % 60
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`
  }

  // body 스크롤 제어
  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [])
  function validatePhoneNumber(number: any) {
    const phonePattern = /^(01[016789])-?\d{4}-?\d{4}$/

    if (phonePattern.test(number)) {
      setPhoneCheck(true)
      return true
    } else {
      setPhoneCheck(false)
      return false
    }
  }

  useEffect(() => {
    if (time === 0) {
      alert('인증번호 입력시간이 끝났습니다. 다시 시도해 주세요.')
      setTime(0)
      setIsActive(false)
    }
  }, [time])

  return (
    <>
      <PageTitle className='small' style={{ padding: '0 16px' }}>
        변경하실 휴대폰번호를<br></br>입력해주세요.
      </PageTitle>
      <div className='member_wrap'>
        <div className='profile_wrap'>
          <div className='profile_info'>
            <div className='inp_box'>
              <p>
                휴대폰 번호
                {phoneNumber && !phonecheck ? <em>휴대폰번호를 확인해주세요.</em> : null}
              </p>

              <div className='phone_cont '>
                <input
                  type='text'
                  placeholder='휴대폰번호'
                  pattern='[0-9]*'
                  inputMode='numeric'
                  value={phoneNumber} // controlled input으로 만들어 줍니다
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, '').slice(0, 11)
                    setPhoneNumber(value)
                    validatePhoneNumber(value)
                  }}
                  style={{ outline: 'none' }}
                  maxLength={11}
                />

                {phoneSubmit ? (
                  seconds === 0 ? (
                    <button
                      type='button'
                      className='certf_btn'
                      style={{ minWidth: '37px' }}
                      onClick={() => {
                        if (phoneNumber && phonecheck) {
                          setPhoneSubmit(true)
                          setIsActive(true)
                          postSendCode(phoneNumber)
                            .then((res) => {
                              setMessageId(res.data.messageId)
                              setSeconds(20)
                              setTime(3 * 59 + 2)
                            })
                            .catch((err) => console.log(err))
                        } else {
                          alert('휴대폰번호를 입력해주세요')
                        }
                      }}
                    >
                      재전송
                    </button>
                  ) : (
                    <p className='certf_btn' style={{ minWidth: 'auto' }}>
                      {seconds}
                    </p>
                  )
                ) : (
                  <button
                    type='button'
                    className='certf_btn'
                    onClick={() => {
                      if (phoneNumber && phonecheck) {
                        setPhoneSubmit(true)
                        setIsActive(true)
                        postSendCode(phoneNumber)
                          .then((res) => {
                            setMessageId(res.data.messageId)
                          })
                          .catch((err) => console.log(err))
                      } else {
                        alert('휴대폰번호를 입력해주세요')
                      }
                    }}
                  >
                    인증요청
                  </button>
                )}
              </div>
            </div>
            {phoneSubmit ? (
              <div className='inp_box'>
                <p>
                  인증번호
                  {authCheck ? <em>인증번호를 잘못 입력했습니다.</em> : null}
                </p>
                <div
                  className={codeFocus ? 'certf_cont' : 'certf_cont'}
                  // style={{
                  //   borderColor: codeFocus
                  //     ? "rgba(255, 23, 23, 0.60)"
                  //     : colorObj.colGray3,
                  // }}
                >
                  <input
                    type='text'
                    inputMode='numeric'
                    placeholder='4자리 인증번호를 입력해주세요.'
                    maxLength={4}
                    onChange={(e) => {
                      setCode(e.target.value)
                    }}
                    onFocus={() => {
                      setCodeFocus(true)
                    }}
                    onBlur={() => {
                      setCodeFocus(false)
                    }}
                    style={{ outline: 'none' }}
                  />
                  <em>{formatTime(time)}</em>
                  <span style={{ color: 'var(--colBlack)' }}>
                    인증번호를 발송했습니다. <br />
                    인증번호가 오지 않는다면 휴대폰번호를 다시 확인해보세요.
                  </span>
                  <button
                    type='button'
                    className={snsCheck ? 'openAuth on' : 'openAuth'}
                    onClick={() => {
                      setSnsCheck((prev: boolean) => !prev)
                    }}
                  >
                    문자가 오지 않았나요?
                  </button>
                  {snsCheck ? (
                    <div className='dropdown_box'>
                      <a
                        href=''
                        onClick={(e) => {
                          e.preventDefault()
                          postKaKao(phoneNumber)
                            .then((res) => {
                              setMessageId(res.data.message)
                            })
                            .catch((err) => console.log(err))
                        }}
                      >
                        카카오톡으로 인증번호 받기
                      </a>
                      <a
                        href=''
                        onClick={(e) => {
                          e.preventDefault()
                          const open: Window | null = window.open('about:blank', '_blank')
                          if (open) {
                            open.location.href = 'https://app-bridge.aboutfishing.kr/faq/37'
                          }
                        }}
                      >
                        인증 문자 오류 해결하기
                      </a>
                    </div>
                  ) : null}
                </div>
              </div>
            ) : null}
          </div>
        </div>
        {phoneSubmit && (
          <div className='bot_txt_box' style={{ width: '237px', margin: '0 auto', position: 'relative' }}>
            <button
              type='button'
              className='btn_save'
              style={{
                borderRadius: '100px',
                background: code.length !== 0 ? 'var(--colBlack)' : 'var(--colGray2)',
                color: code.length !== 0 ? 'var(--colWhite)' : 'var(--colGray4)',
                marginBottom: '24px',
              }}
              onClick={() => {
                postVerifyCode(phoneNumber, messageId, code)
                  .then((response) => {
                    if (isActive)
                      postChangeMobile(changePhone, changeEmail, phoneNumber, response.data.verificationCheckCode)
                        .then((res) => {
                          postLogin(phoneNumber, response.data.verificationCheckCode, os)
                            .then((res) => {
                              if (res.data.code === 'E0123') {
                                setText('agree')
                              } else if (res.data.code === 'E0127') {
                                alert('회원탈퇴 한지 7일이 지나지 않았습니다.')
                              } else if (res.data.code === 'E0125') {
                                alert('회원탈퇴 한지 180일이 지나지 않았습니다.')
                              } else if (res.data.code === 'E0111') {
                                navigate(`/sanctions`, {
                                  state: { userData: res.data },
                                })
                              } else {
                                window.localStorage.setItem(`aboutRefreshToken`, JSON.stringify(res.data.refreshToken))
                                window.localStorage.setItem(`aboutAccessToken`, JSON.stringify(res.data.accessToken))
                                postOpenid(res.data.accessToken)
                                  .then((res) => {
                                    alert('휴대폰 번호가 변경되었습니다')
                                    window.localStorage.setItem(`accessToken`, JSON.stringify(res.data.accessToken))
                                    closeModal()
                                    handleAccessToken()
                                    window.location.reload()
                                  })
                                  .catch((err) => {
                                    setAuthCheck(true)
                                    window.localStorage.setItem(`aboutRefreshToken`, JSON.stringify([]))
                                    window.localStorage.setItem(`aboutAccessToken`, JSON.stringify([]))
                                  })
                              }
                              if (res.data.code !== 'E0135') {
                                // setText("login");
                              } else {
                                setCodeCheck(true)
                              }
                            })
                            .catch((err) => setCodeCheck(true))
                        })
                        .catch((err) => {
                          console.log(err)
                        })
                  })
                  .catch((err) => {
                    setCodeCheck(true)
                  })
              }}
            >
              확인
            </button>
          </div>
        )}
      </div>
    </>
  )
}
